import {ChangeDetectionStrategy, Component} from "@angular/core";
import {FUIAbstractFascia} from "../../abstract-fascia";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-header-fascia",
    styleUrls: ["./header-fascia.component.scss"],
    templateUrl: "./header-fascia.component.html"
})
export class FUIHeaderFasciaComponent extends FUIAbstractFascia {
}
